"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
exports.createSkeletonStyle = function (color) { return ({
    backgroundColor: color,
    color: color,
}); };
exports.contextTypes = {
    skeletor: PropTypes.shape({
        isPending: PropTypes.bool,
        styling: PropTypes.func
    })
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// /Users/alexandrer/development/react-skeletor/lib/utils.js
// module id = 137
// module chunks = 0